"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[902],{

/***/ 24445:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/barrier-own.8082cfc5.svg","height":100,"width":100});

/***/ }),

/***/ 8085:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/bat-own.95b53b4a.svg","height":100,"width":100});

/***/ }),

/***/ 83989:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/speaker-own.34ca439e.svg","height":100,"width":100});

/***/ }),

/***/ 28951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ decodeGroupedAnalysis1; },
  "a": function() { return /* binding */ useGroupedAnalysis1; }
});

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/duration.ts
var duration = __webpack_require__(5964);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(66604);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
;// CONCATENATED MODULE: ./src/mainsite/api/burn-records.ts


const decodeBurnRecords = (rawBurnRecords)=>({
        ...rawBurnRecords,
        records: mapValues_default()(rawBurnRecords.records, (records)=>records.map((record)=>({
                    ...record,
                    minedAt: parseISO/* default */.Z(record.minedAt)
                })))
    });

// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/grouped-analysis-1.ts




const decodeGroupedAnalysis1 = (raw)=>raw === undefined ? undefined : {
        ...raw,
        burnRecords: decodeBurnRecords({
            number: raw.number,
            records: raw.burnRecords
        }).records
    };
const useGroupedAnalysis1 = ()=>{
    const { data  } = (0,dist/* default */.ZP)("/api/fees/grouped-analysis-1", fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: duration/* millisFromSeconds */.Io(4)
    });
    return data;
};


/***/ }),

/***/ 88902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_GasStreakWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceStrict/index.js + 3 modules
var formatDistanceStrict = __webpack_require__(63016);
// EXTERNAL MODULE: ./src/components/TextsNext/LabelText.tsx
var LabelText = __webpack_require__(89802);
// EXTERNAL MODULE: ./src/components/TextsNext/LabelUnitText.tsx
var LabelUnitText = __webpack_require__(76688);
// EXTERNAL MODULE: ./src/components/TextsNext/QuantifyText.tsx
var QuantifyText = __webpack_require__(90079);
// EXTERNAL MODULE: ./src/components/TextsNext/SkeletonText.tsx
var SkeletonText = __webpack_require__(7569);
// EXTERNAL MODULE: ./src/components/WidgetSubcomponents/index.tsx
var WidgetSubcomponents = __webpack_require__(69443);
// EXTERNAL MODULE: ./src/format.ts
var format = __webpack_require__(12597);
// EXTERNAL MODULE: ./src/fp.ts
var fp = __webpack_require__(96019);
// EXTERNAL MODULE: ./src/mainsite/api/grouped-analysis-1.ts + 1 modules
var grouped_analysis_1 = __webpack_require__(28951);
// EXTERNAL MODULE: ./src/mainsite/hooks/use-now.ts
var use_now = __webpack_require__(98320);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./src/assets/barrier-own.svg
var barrier_own = __webpack_require__(24445);
// EXTERNAL MODULE: ./src/assets/bat-own.svg
var bat_own = __webpack_require__(8085);
// EXTERNAL MODULE: ./src/assets/speaker-own.svg
var speaker_own = __webpack_require__(83989);
;// CONCATENATED MODULE: ./src/mainsite/components/UltraSoundBarrier.tsx





const UltraSoundBarrier = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inline-flex select-none gap-x-1",
        title: "ultra sound barrier",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-4 w-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "bat emoji",
                    src: bat_own/* default */.Z
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-4 w-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "speaker emoji",
                    src: speaker_own/* default */.Z
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-4 w-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "barrier emoji",
                    src: barrier_own/* default */.Z
                })
            })
        ]
    });
/* harmony default export */ var components_UltraSoundBarrier = (UltraSoundBarrier);

;// CONCATENATED MODULE: ./src/mainsite/components/GasStreakWidget.tsx












const SpanningAge = (param)=>{
    let { isLoading , startedOn  } = param;
    var ref;
    const now = (0,use_now/* useNow */.m)();
    const startedOnO = (0,fp/* pipe */.zG)(startedOn, fp.O.fromNullable, fp.O.map(parseISO/* default */.Z));
    const formattedDistance = (0,fp/* pipe */.zG)(fp/* OAlt.sequenceTuple */.n.sequenceTuple(startedOnO, now), fp.O.map((param)=>{
        let [startedOn, now] = param;
        return formatDistanceStrict/* default */.Z(startedOn, now, {
            roundingMethod: "floor"
        });
    }));
    const formattedNumber = (0,fp/* pipe */.zG)(formattedDistance, fp.O.match(()=>0, (formattedDistance)=>Number(formattedDistance.split(" ")[0])));
    const formattedUnit = (ref = fp.O.toUndefined(formattedDistance)) === null || ref === void 0 ? void 0 : ref.split(" ")[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-x-1 items-baseline",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                size: "text-4xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                    width: "2rem",
                    children: isLoading ? undefined : formattedNumber
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                color: "text-slateus-200",
                className: "ml-1",
                size: "text-4xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                    width: "8rem",
                    children: isLoading ? undefined : formattedUnit !== null && formattedUnit !== void 0 ? formattedUnit : "seconds"
                })
            })
        ]
    });
};
const GasStreakWidget = (param)=>{
    let { blobFees  } = param;
    var ref;
    const groupedAnalysis1F = (0,grouped_analysis_1/* useGroupedAnalysis1 */.a)();
    const groupedAnalysis1 = (0,grouped_analysis_1/* decodeGroupedAnalysis1 */.h)(groupedAnalysis1F);
    const deflationaryStreak = (ref = blobFees ? groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.deflationaryBlobStreak : groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.deflationaryStreak) === null || ref === void 0 ? void 0 : ref.postMerge;
    const title = blobFees ? "blob gas streak" : "gas streak";
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetBackground */.K, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-2 items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanningAge, {
                    isLoading: deflationaryStreak === undefined,
                    startedOn: (ref1 = deflationaryStreak === null || deflationaryStreak === void 0 ? void 0 : deflationaryStreak.startedOn) !== null && ref1 !== void 0 ? ref1 : undefined,
                    count: (ref2 = deflationaryStreak === null || deflationaryStreak === void 0 ? void 0 : deflationaryStreak.count) !== null && ref2 !== void 0 ? ref2 : undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-x-1 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-x-1 items-baseline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelUnitText/* LabelUnitText */.B, {
                                    className: "mt-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                        width: "3rem",
                                        children: deflationaryStreak === undefined ? undefined : deflationaryStreak === null ? 0 : (0,format/* formatZeroDecimals */.UY)(deflationaryStreak.count)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                                    className: "mt-1",
                                    children: (deflationaryStreak === null || deflationaryStreak === void 0 ? void 0 : deflationaryStreak.count) === 1 ? " block" : " blocks"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                                    className: "mt-1",
                                    color: "text-slateus-400",
                                    children: "above"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UltraSoundBarrier, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_GasStreakWidget = (GasStreakWidget);


/***/ }),

/***/ 98320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useNow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96019);


const useNow = ()=>{
    const [now, setNow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_fp__WEBPACK_IMPORTED_MODULE_1__.O.none);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const interval = setInterval(()=>{
            setNow(_fp__WEBPACK_IMPORTED_MODULE_1__.O.some(new Date()));
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    return now;
};


/***/ })

}]);